<template>
  <div class='shareSheetModel-box'>
    <ShareSheet v-model="showShare" title="分享到" :options="options" @select="onSelect"/>
  </div>
</template>

<script>
/* ======= 组件 ======= */
import { ShareSheet } from '@yunji/h5'
// import YunJi from '@/assets/js/YunJi'
import { shareWxInApp } from '../util' 

export default {
  name: 'shareSheetModel',
  components: {
    ShareSheet
  },
  data() {
    return {
      options: [
        { code: 'WX', name: '微信', icon: 'wechat' },
        { code: 'COPY', name: '复制链接', icon: 'link' }
      ],
      showShare: false
    }
  },
  created() {
    this.$root.$on('showShareSheet', this.showFn)
  },
  beforeDestroy() {
    this.$root.$off('showShareSheet')
  },
  methods: {
    showFn() {
      this.showShare = true
    },
    onSelect(option) {
      this.showShare = false
      const { code } = option
      if (code == 'WX') {
        // 分享微信
        shareWxInApp(window.location.href, '云集分类页', '全网爆款，尽在云集', 'https://static.yunjiglobal.com/qnUpload/frontend/config/share_category.png')
      } else {
        // 复制链接
        window.location.href = `yunji://common/copy_text?text=${encodeURIComponent(`${window.location.href}`)}`
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .shareSheetModel-box{
    background-color: #fff;
    /deep/ .van-share-sheet__options{
      display: flex;
      justify-content: space-around;
      padding-top: 38px;
    }
  }
</style>
